import "./About.css"

function About() {
  return (
    <section className="about" id="about">
      <div className="container">
        <h2 className="section-title">About Us & Our Team</h2>
        <div className="about-content">
          <div className="about-image">
            <img src="/images/aboutteam.png?height=400&width=400" alt="Team Illustration" />
          </div>
          <div className="about-text">
            <h3>
              We Are <span className="highlight">Babita Pack consultancy service</span>,<br />
              Packaging Solutions Provider.
            </h3>
            <p>
               We are a leading packaging consultant service dedicated to helping businesses worldwide
               enhance their packaging strategies.

            </p>
            <p>
            Our team of experts combines industry knowledge, creative thinking,
                and sustainability principles to deliver innovative and cost-effective packaging solutions. With a focus
                 on customer satisfaction and environmental responsibility, we strive to exceed expectations and drive positive 
                 impact in the packaging industry.
            </p>
            <button className="about-button">Continue &gt;</button>
          </div>
        </div>
      </div>
    </section>
  )
}

export default About

